import React from 'react';
import { AlertCircle, Inbox } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';

interface QueryStateMessageProps {
  isLoading: boolean;
  isError: boolean;
  isEmpty: boolean;
  errorMessage: string;
  emptyMessage: string;
  onRetry: () => void;
  children: React.ReactNode;
}

// Shared loading / error / empty states for the pre-registration tables
export const QueryStateMessage: React.FC<QueryStateMessageProps> = ({
  isLoading,
  isError,
  isEmpty,
  errorMessage,
  emptyMessage,
  onRetry,
  children,
}) => {
  if (isLoading) {
    return (
      <div className="space-y-2">
        {Array.from({ length: 5 }).map((_, index) => (
          <Skeleton key={index} className="h-10 w-full" />
        ))}
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex flex-col items-center gap-3 py-10 text-center">
        <AlertCircle className="h-8 w-8 text-destructive" />
        <p className="text-sm text-gray-700">{errorMessage}</p>
        <Button variant="outline" size="sm" onClick={onRetry}>
          Reintentar
        </Button>
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className="flex flex-col items-center gap-3 py-10 text-center">
        <Inbox className="h-8 w-8 text-gray-400" />
        <p className="text-sm text-gray-600">{emptyMessage}</p>
      </div>
    );
  }

  return <div>{children}</div>;
};
